import type { FC } from 'react';
import EmbedYoutube from '../utils/EmbedYoutube/EmbedYoutube';
import { InterviewProgramsWrapper } from './InterviewPrograms.styled';

interface InterviewProgramsProps { }

const InterviewPrograms: FC<InterviewProgramsProps> = () => (
   <InterviewProgramsWrapper data-testid="InterviewPrograms">
      <header className="entry-header ">
         <h1 className="entry-title" itemProp="headline">Interview Programs</h1>
      </header>
      <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
         <p className="text-align-justify">We will be covering the following interview questions :</p>
         <ul className="text-align-justify">
            <li><a href="/java-programs">Java Interview Programs</a></li>
            <li><a href="/stream-api-programs">Stream API Programs</a></li>
            <li><a href="/dp-programs">Dynamic Programming Programs</a></li>
         </ul>
      </div>
      <br/>
      <hr />
      <br />
      <EmbedYoutube videoType="playlist" videoList={["IQdr_2Aww8Q","BcQPtriMT5g"]} />
      <br/>

   </InterviewProgramsWrapper>
);

export default InterviewPrograms;
